function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".avatarFill-1{fill:#fff;}.avatarFill-2{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "avatar");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "SvgjsG1008"
}, /*#__PURE__*/React.createElement("path", {
  className: "avatarFill-1",
  d: "M144,56a44,44,0,1,0,44,44A44,44,0,0,0,144,56Zm0,110c-29.32,0-88,14.69-88,44v22H232V210C232,180.69,173.32,166,144,166Z",
  transform: "translate(-12 -12)"
}), /*#__PURE__*/React.createElement("path", {
  className: "avatarFill-2",
  d: "M12,12H276V276H12Z",
  transform: "translate(-12 -12)"
}));

var SvgAvatar = function SvgAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1001",
    viewBox: "0 0 264.01 264.01",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar.faa61cd8.svg";
export { ForwardRef as ReactComponent };